import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaInbox } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { FaShoppingCart } from "react-icons/fa";
import { FaBookOpen } from "react-icons/fa";
import { FaRegCalendarAlt } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useCourseStore } from "../../store/useCourseStore";

const Footer = () => {
    const location = useLocation()
    const { t } = useTranslation()
    const navigate = useNavigate()
    const isActive = (path: string) => {
        if (path === "/") return location.pathname === path
        return location.pathname.startsWith(path);
    }
    const lastVisitedCourseId = useCourseStore((state) => state.lastVisitedCourseId)

    const handleNavigation = (path: string) => {
        if (path === "/") {
            if (lastVisitedCourseId) {
                return navigate(`/course/${lastVisitedCourseId}`)
            }
        }
        return navigate(path)
    }

    return (
        <footer className="footer-nav-wrapper">
            <button className={`footer-nav-single ${isActive("/") ? "active" : ""}`} onClick={() => handleNavigation("/")} >
                <div className="menu-wrapper">
                    <FaBookOpen style={{color: isActive("/") ? "white" : ""}}/>
                    <span>{t("footer.home")}</span>
                </div>
            </button>
            <button className={`footer-nav-single ${isActive("/cart") ? "active" : ""}`} onClick={() => navigate("/cart")} >
                <div className="menu-wrapper">
                    <FaShoppingCart style={{color: isActive("/cart") ? "white" : ""}}/>
                    <span>{t("footer.cart")}</span>
                </div>
            </button>
            <button className={`footer-nav-single ${isActive("/inbox") ? "active" : ""}`} onClick={() => navigate("/inbox")} >
                <div className="menu-wrapper">
                    <FaInbox style={{color: isActive("/inbox") ? "white" : ""}}/>
                    <span>{t("footer.inbox")}</span>
                </div>
            </button>
            <button className={`footer-nav-single ${isActive("/schedule") ? "active" : ""}`} onClick={() => navigate("/schedule")} >
                <div className="menu-wrapper">
                    <FaRegCalendarAlt style={{color: isActive("/schedule") ? "white" : ""}}/>
                    <span>{t("footer.schedule")}</span>
                </div>
            </button>
            <button className={`footer-nav-single ${isActive("/profile") ? "active" : ""}`} onClick={() => navigate("/profile")} >
                <div className="menu-wrapper">
                    <FaUser style={{color: isActive("/profile") ? "white" : ""}}/>
                    <span>{t("footer.profile")}</span>
                </div>
            </button>
        </footer>
    );
};

export default Footer;
